import * as React from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import "font-awesome/css/font-awesome.min.css";
import { Animated } from "react-animated-css";
import Modal from "react-awesome-modal";
import Loader from "react-loader";
import { Redirect } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CSSTransition } from "react-transition-group";
import Tour from "reactour";
import { Row } from "reactstrap";
import Enquiry from "src/common/enquiries.Component";
import PendingAssessment from "src/components/Ploa2Cards/PendingAssessment";
import ScoreSummary from "src/components/ScoreSummary/ScoreSummary.component";

import BadgesDisplay from "../../common/badgesDisplay.Component";
// toast component
import { SOCKET } from "../../common/constants";
import SearchFilterCourseItem from "../../common/CourseDisplays/SearchFilterCourseItem";
import CustomAlertSpeedometer from "../../common/CustomAlertSpeedo.Component";
import BubbleChart from "../../common/DataViz/bubbleChart.Component";
import LessonItem from "../../common/lessonItem.Component";
import {
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  isBasicPreassessmentDone,
  isUserLoggedIn,
  isUserUpgraded,
  setSelectedCalendarDay,
  setCurrentLesson,
  currentLesson,
  currentSubscriptionLevel,
  isLessonsEnabled,
  currentTargetGroup,
  isSubscriptionOwner,
  clearSessionData,
  userFirstName,
  plLevel,
  currentUserId,
  requiredPloa,
} from "../../common/services";
import StudentStory from "../../common/studentStory.Component";
import SvgDisplay from "../../common/svgDisplay";
import ScrollCard from "../../components/Card";
import CustomNav from "../../components/CustomNav/CustomNav.Component";
import Vimeo from "../../components/VimeoPlayer/VimeoPlayer.Component";
import withServices from "../../HOCs/withServices";
import { links } from "./courseVideosLinks";
import { tourSteps } from "./StudentHomeTour";

import "./commonHomePage.css";
import { decodeSocketMessage } from "src/common/utils";

interface IProps {
  history: any;
  services: any;
}
class StudentHomePage extends React.Component<IProps> {
  public state = {
    activeTab: "1",
    currentNavLink: "1",
    assessmentinfo: {},
    badges: [],
    baseurl: currentBaseUrl(),
    cardbutton: {
      borderRadius: 10,
      fontSize: 11,
      margin: 3,
      marginBottom: 7,
      marginTop: 14,
    },
    gaugescore: 1,
    gaugewidth: 0,
    height: 0,
    infofields: {
      id: "id",
    },
    lessonallocations: [] as any,
    completedLessons: [],
    completedLessonsCounted: false,
    lessonsLoaded: false,
    lessonsLoading: true,
    selectedCourseId: 0,
    lessons: [],
    activeCourses: [] as any,
    activeLessons: [] as any,
    loaded: false,
    coursesloaded: false,
    mounted: false,
    nextlesson: {} as any,
    resultfields: {
      info: "assessment_info",
      results: "results",
    },
    ticks: [
      { label: "&&&&Severe Alert", value: 0 },
      { label: "High Alert", value: 3 },
      { label: "Moderate Alert", value: 5 },
      { label: "Low Alert", value: 7.5 },
      { label: "No Alert", value: 9 },
    ],
    tologin: false,
    topreassessment: false,
    topreassessmentresult: false,
    toProfile: false,
    toupgradedpreassessment: false,
    username: "",
    width: 0,
    toCalendar: false,
    // calendar state
    date: new Date(),
    // setting up lessons clicks
    currentLesson: {},
    navigate: false,
    destination: "",
    scrollpos: 0,
    recommendedCoursesLoaded: [],
    recommendedCourses: [],
    currentCourse: {},
    modalOpen: false,
    clickedBadge: null,
    topBehaviours: [],
    bottomBehaviours: [],
    behavioursLoaded: false,
    allBehaviours: {
      AssessmentName: "",
      behaviours: [],
    },
    allBehavsLoaded: false,
    behaveModalOn: false,
    hasActiveSubscription: false,
    assessmentAvailable: false,
    assessmentID: null,
    assessModalOpen: false,
    userInterested: null,
    guidesRead: true,
    standardScores: null,
    scoresLoaded: false,
    openInactiveModal: false,
    lessonStartDetails: {
      lesson: {},
      isActive: false,
      completed: false,
      nextLesson: undefined,
      event: null,
    },
    lessonStartWarningModal: false,
    nextCourseModalOpen: false,
    assessments: [],
    openDownloadModal: false,
    sid: null,
    showCourseVideo: false,
    courseVideo: "",
    refreshInterval: null as any,
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.setTab = this.setTab.bind(this);
    this.handleLessonClick = this.handleLessonClick.bind(this);
    this.handleCalendarClick = this.handleCalendarClick.bind(this);
    this.realoadInfo = this.realoadInfo.bind(this);
    this.handleCourseClick = this.handleCourseClick.bind(this);
    this.toHelpCenter = this.toHelpCenter.bind(this);
    // this.startCurrentLesson = this.startCurrentLesson.bind(this);
    this.toDataCenterTemp = this.toDataCenterTemp.bind(this);
    // this.filterCompletedLessons = this.filterCompletedLessons.bind(this);
    // this.totalCourseDuration = this.totalCourseDuration.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.toggleBehavModal = this.toggleBehavModal.bind(this);
    this.badgesModal = this.badgesModal.bind(this);
    this.handleBadgeClick = this.handleBadgeClick.bind(this);
    // this.renderTopBottomBehaviours = this.renderTopBottomBehaviours.bind(this);
    this.renderAllBehaviours = this.renderAllBehaviours.bind(this);
    this.checkLessonStartValidity = this.checkLessonStartValidity.bind(this);
    this.fetchStudentAssessments = this.fetchStudentAssessments.bind(this);
    this.downloadAssessmentReport = this.downloadAssessmentReport.bind(this);
    this.startNextCourse = this.startNextCourse.bind(this);
    this.fetchLessons = this.fetchLessons.bind(this);
  }

  public fetchLessons = async () => {
    const lessonsRes =
      await this.props.services.studentsAPI.getLessonAllocations();
    if (lessonsRes.ok) {
      const lessons = lessonsRes.data.lessonallocations;

      const set = new Set();
      const completed = new Array();

      lessons.map((item) => {
        set.add(item.SearchFilterId);
        if (item.Completed) {
          completed.push(item);
        }
      });

      const activeCourses = Array.from(set);

      this.setState({
        activeLessons: lessons,
        activeCourses,
        completedLessons: completed,
      });
    }

    const nextLessonEta =
      await this.props.services.studentsAPI.getUserNextLessonEta();

    if (nextLessonEta.ok) {
      this.setState({
        nextlesson: nextLessonEta.data.nextlesson,
      });
    }
  };

  public async componentDidMount() {
    SOCKET.on("connect", this.onSocketConnect);
    SOCKET.on("customEmit", (data) => this.onSetup(data));
    SOCKET.on("customNotif", (data) => this.onMessage(data));
    // start socket
    SOCKET.emit("customMsg", { evt: "init" });

    // gettins lessons data
    // getGeneralSmartTableData( 'admin/lessons/overview_items/', text => this.handleGenSmartDataLoaded('lessons', 'lessons',text));
    if (!isUserLoggedIn()) {
      this.setState({ tologin: true });
      return;
    }

    // console.log("basicPReAssess: ", isBasicPreassessmentDone());

    if (!isBasicPreassessmentDone()) {
      this.setState({ topreassessment: true });
    }

    const assessmentRes =
      await this.props.services.adminAPI.getNextAssessment();
    // console.log("ASSiNFO: " + JSON.stringify(assessmentRes, null, 2));
    if (assessmentRes.ok) {
      const assessmentInfo = assessmentRes.data;
      if (assessmentInfo.status === "available") {
        this.setState({
          assessmentAvailable: true,
          assessmentID: assessmentInfo.assessment_id,
          assessModalOpen: true,
        });
      } else {
        this.setState({ assessmentAvailable: false });
      }
    }

    const scoreRes = await this.props.services.studentsAPI.getPlexHomeStats();
    if (scoreRes.ok) {
      this.setState({
        standardScores: scoreRes.data,
        scoresLoaded: true,
      });
    }

    // get all lesson allocations for a course
    // getGeneralSmartTableData("overview/lesson_allocations", (text) =>
    //   this.handleGenSmartDataLoaded(
    //     "lessonallocations",
    //     "lessonallocations",
    //     text
    //   )
    // );

    const lessonsRes =
      await this.props.services.studentsAPI.getLessonAllocations();
    if (lessonsRes.ok) {
      const lessons = lessonsRes.data.lessonallocations;

      const set = new Set();
      const completed = new Array();

      lessons.map((item) => {
        set.add(item.SearchFilterId);
        if (item.Completed) {
          completed.push(item);
        }
      });

      const activeCourses = Array.from(set);

      this.setState({
        activeLessons: lessons,
        activeCourses,
        completedLessons: completed,
      });
    }

    const nextLessonEta =
      await this.props.services.studentsAPI.getUserNextLessonEta();

    if (nextLessonEta.ok) {
      this.setState({
        nextlesson: nextLessonEta.data.nextlesson,
      });
    }

    getGeneralSmartTableData(
      "admin/badge_allocations/achievement_summary/",
      (text) => this.handleGenSmartDataLoaded("badges", "badges", text)
    );

    // getGeneralSmartTableData("lesson_allocations/next_lesson_due/", (text) =>
    // this.handleGenSmartDataLoaded("nextlesson", "nextlesson", text)
    // );

    this.setState({ mounted: true });
    // recommended courses
    const {
      services: { studentsAPI, fixturesAPI },
    } = this.props;

    const refreshInterval = setInterval(() => {
      this.fetchLessons();
    }, 100000);

    this.setState({ refreshInterval });

    const response = await studentsAPI.getSearchFilterList();
    if (response.ok) {
      const recommendedCourses = response.data.search_filters;
      // console.log("RecommendedC:" + JSON.stringify(recommendedCourses, null, 2));
      this.setState({ recommendedCourses });
      this.handleCourseClick(recommendedCourses[0].SearchFilterId);
    } else {
      // toast.error("Recommended Courses not found, try again!");
    }

    const tourStatus = localStorage.getItem(
      `${this.props.services.currentUsername}StudentHomeTour`
    );
    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }
  }

  public onSocketConnect = () => {
    console.log("connected");
  };

  public onMessage = (socketMessage) => {
    // this.setState({ socketLoading: false });
    const dataObj = decodeSocketMessage(socketMessage);
    const link = dataObj.message.data.link;
    window.open(link, "_blank");
  };

  public onSetup = (message) => {
    this.setState({ sid: message.id });
  };

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}StudentHomeTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  public handleAssessmentResultsLoaded(res) {
    if (res.code === 200) {
      // console.log("responseloaded:", res.response);
      this.setState({ loaded: true });
      this.setState({ assessmentinfo: res.response });
    }

    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  // lesson data
  public handleGenSmartDataLoaded(key, objkey, res) {
    if (res.code === 200) {
      // console.log("THE KEY IS " + objkey);
      this.setState({ loaded: true });
      this.setState({ [key]: res.response[objkey] });
      if (key === "lessonallocations") {
        // this.filterCompletedLessons();
        // this.setState({ lessonsLoaded: true });
      }
    }
    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public onLogout(arg) {
    clearSessionData();
    this.setState({ tologin: true });
  }

  public onProfile = () => {
    this.props.history.push(`${currentBaseUrl()}profilepage`);
  };

  public setTab(param, e) {
    this.setState({
      activeTab: param,
      currentNavLink: param,
    });
  }

  public currentid() {
    const key1 = "match";
    return this.props[key1].params.id;
  }

  public chosendesiignation() {
    const key1 = "match";
    return this.props[key1].params.designation;
  }

  public toHelpCenter() {
    // this.setState({ destination: "/helpcenter", navigate: true });
    toast.info("You cannot check in at the moment!");
  }

  public onChange(arg) {
    // console.log("On change", arg);
    // this.setState({date:})
  }

  public toPurchaseSubscription = () => {
    // setTimeout(() => {
    //   this.props.history.push(`${currentBaseUrl()}subscription`);
    // }, 4000);
    toast.warn(
      "Ooopps, it looks like you’re School / College has not upgraded your package yet, hold tight and we will talk to them"
    );
  };

  public toDataCenterTemp() {
    if (currentSubscriptionLevel() < 1 || isLessonsEnabled() === false) {
      if (currentTargetGroup() === "schools") {
        toast.warn("Your performance has been sent to your school!");
        return;
      } else {
        // toast.warn("Your subscription does not support this feature. Upgrade!");
        this.toPurchaseSubscription();
      }
    } else {
      const { history } = this.props;
      const destination = currentBaseUrl() + "datacentre";
      history.push(destination);
    }
  }

  public async startNextCourse() {
    console.log("Starting next course");

    this.setState({
      lessonsLoading: true,
      nextCourseModalOpen: false,
    });

    const courseId = this.state.selectedCourseId;

    const reqRes = await this.props.services.studentsAPI.requestNextCourse(
      courseId
    );
    if (reqRes.ok) {
      this.setState({
        lessonsLoading: false,
      });

      if (!reqRes.data.success) {
        toast.error(
          "Sorry we could not find a lesson for you at the moment! Try again later!"
        );
        return;
      }

      toast.success(
        "Next course started! Please wait five minutes for the course to appear in your dashboard."
      );
    } else {
      toast.error("Could not start next course, try again later!");
      this.setState({
        lessonsLoading: false,
      });
    }
  }

  public async handleCourseClick(id) {
    const { activeLessons } = this.state;

    this.setState({ lessonsLoading: true });

    if (this.state.activeCourses.includes(id)) {
      const filtered = activeLessons.filter(
        (lesson) => lesson.SearchFilterId === id
      );

      // sort lessons by LessonOrder
      filtered.sort((a, b) => a.LessonOrder - b.LessonOrder);

      this.setState({
        lessonallocations: filtered,
        lessonsLoading: false,
        selectedCourseId: id,
      });
    } else {
      const res = await this.props.services.studentsAPI.getCoursesSF(id);

      if (res.ok) {
        const lessonAllocations = res.data.lessons;
        lessonAllocations.sort((a, b) => a.lessonOrder - b.LessonOrder);
        this.setState({
          lessonallocations: lessonAllocations,
          selectedCourseId: id,
          lessonsLoading: false,
        });
      } else {
        toast.error("Sorry, we could not find your lessons, try again later! ");
        this.setState({ lessonsLoading: false });
      }
    }
  }

  public handleShowCourseVideo = (sfId) => {
    const ploaLevel = requiredPloa();
    const vidKey =
      ploaLevel === "PLOA_SECONDARY" ? "secondaryVid" : "primaryVid";
    const current: any = links.find((item) => item.SearchFilterId === sfId);
    this.setState({ showCourseVideo: true, courseVideo: current[vidKey] });
  };

  public async fetchStudentAssessments() {
    console.log(currentUserId);
    const {
      services: { adminAPI },
    } = this.props;

    const res = await adminAPI.getUserAssessmentsList(currentUserId());

    this.setState({
      assessments: res.data.assessments,
      openDownloadModal: true,
    });
  }

  public async downloadAssessmentReport(e) {
    const { sid } = this.state;
    const {
      services: { institutionsAPI },
    } = this.props;

    const downloadRes = await institutionsAPI.generateStudentAssessmentReport(
      currentUserId(),
      e.target.value,
      sid
    );
    if (downloadRes.ok) {
      this.setState({ openDownloadModal: false, downloadComplete: true });
    } else {
      toast.error("Ooops, the report could not be generated, try again.");
    }
  }

  public componentWillUnmount() {
    // kill listeners if any
    SOCKET.off("CustomNotif");

    // remove interval
    clearInterval(this.state.refreshInterval);
  }

  public async realoadInfo() {
    getGeneralSmartTableData("overview/lesson_allocations", (text) =>
      this.handleGenSmartDataLoaded(
        "lessonallocations",
        "lessonallocations",
        text
      )
    );
    // getGeneralSmartTableData(
    //   "admin/assessments/get_latest_user_assessment_details/",
    //   text => this.handleAssessmentInfoLoaded(text)
    // );
    getGeneralSmartTableData("lesson_allocations/next_lesson_due/", (text) =>
      this.handleGenSmartDataLoaded("nextlesson", "nextlesson", text)
    );
    // getGeneralSmartTableData("admin/courses/recommended_courses/", text => this.handleRecommendedCoursesLoaded(text));
  }

  public booleanText(bool) {
    if (bool) {
      return "Yes";
    } else {
      return "No";
    }
  }

  public async toggleUserInterest(status) {
    const item = {
      comment: status ? "Yes" : "No",
    };
    this.setState({ userInterested: status });
    const {
      services: { adminAPI },
    } = this.props;
    const res = await adminAPI.captureUserInterest(item);
    if (res.ok) {
      toast.success("Thank you!");
    } else {
      toast.warn("Ooops, please try again");
    }
  }

  public svgInfo() {
    const {
      completedLessons,
      lessonallocations,
      completedLessonsCounted,
      lessonsLoading,
      activeLessons,
    } = this.state;
    // console.log("Completed lessons: " + completedLessons.length);
    if (!lessonsLoading) {
      const nxtkey = "eta";
      return (
        <React.Fragment>
          <p className="results-title">MY PERFORMANCE LEARNING JOURNEY</p>

          <div className="svg-card step-3">
            {/* {this.totalCourseDuration()} */}
            {/* two props expected, totalnumber of lessons and lessons completed */}
            <SvgDisplay
              totalLessons={activeLessons.length}
              completedLessons={completedLessons.length}
              currentLessons={lessonallocations}
              onStartLesson={this.handleLessonClick}
            />

            <div className="progress-detail">
              <p
                className="motivation"
                style={{ paddingLeft: "4em", display: "none" }}
              >
                Get to the next stop before the due date and get your badge
              </p>
              <p style={{ display: "none" }} className="next-stop">
                <span>
                  Next Lesson is due in{" "}
                  <span>{this.state.nextlesson[nxtkey]} days</span>
                </span>{" "}
                <br />
                {/* {lessonallocations[lessonCount].Title} */}
              </p>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff2400" />;
    }
  }

  public recommendedCourses() {
    const { recommendedCourses, activeCourses } = this.state;

    recommendedCourses.sort((a: any, b: any) => {
      if (activeCourses.includes(a.SearchFilterId)) {
        return -1;
      }

      if (activeCourses.includes(b.SearchFilterId)) {
        return 1;
      } else {
        return 0;
      }
    });

    if (isUserUpgraded() && recommendedCourses.length) {
      return (
        <React.Fragment>
          <p className="results-title">Your PERFORMANCE LEARNING Journey</p>

          <div className="courses-display">
            <div className="course-container">
              {recommendedCourses.map((course: any, i) => (
                <SearchFilterCourseItem
                  onCourseClick={this.handleCourseClick}
                  onShowVideo={this.handleShowCourseVideo}
                  key={`sf-course-${i}`}
                  icon={course.Thumbnail}
                  sfId={course.SearchFilterId}
                  selected={this.state.selectedCourseId}
                  isActive={this.state.activeCourses.includes(
                    course.SearchFilterId
                  )}
                />
              ))}
            </div>
          </div>
          {/* <RecommendedCoursesDisplay allCourses={recommendedCourses} /> */}
        </React.Fragment>
      );
    } else {
      return <Loader color="#3ee9f700" />;
    }
  }

  public textInfo() {
    if (this.state.assessmentinfo[this.state.resultfields.results]) {
      return (
        <CustomAlertSpeedometer
          alertLevel={7}
          assessmentLevel={Math.round(
            this.state.assessmentinfo[this.state.resultfields.results].PLOAScore
          )}
        />
      );
    } else {
      return <div />;
    }
  }
  public risklevelTitle() {
    if (this.state.assessmentinfo[this.state.resultfields.results]) {
      return (
        <div className="card-intro">
          <h4 className="assessment-header">
            {
              this.state.assessmentinfo[this.state.resultfields.results]
                .RiskLevel
            }
            :{" "}
            {
              this.state.assessmentinfo[this.state.resultfields.results]
                .TraitTitle
            }
          </h4>

          <p className="assessment-info">
            {
              this.state.assessmentinfo[this.state.resultfields.results]
                .TraitCopy
            }
          </p>
          {/* 
          <div className="bottom-content">
            <button
              className="green-button watch-video"
              onClick={this.toDataCenterTemp}
            >
              Learn more in the Data center
            </button>
          </div> */}
        </div>
      );
    } else {
      return <Loader color="#3ee9f700" />;
    }
  }

  public async checkLessonStartValidity(
    lesson,
    isActive,
    completed,
    nextLesson,
    e
  ) {
    if (!isActive) {
      this.setState({ openInactiveModal: true });
      return;
    }

    const res =
      await this.props.services.adminAPI.getNextLessonCompletionDate();

    if (!res.data.can_complete_lesson) {
      this.setState({
        lessonStartWarningModal: true,
        lessonStartDetails: {
          lesson,
          isActive,
          completed,
          nextLesson,
          event: null,
        },
      });
    } else {
      this.handleLessonClick(lesson, isActive, completed, nextLesson, e);
    }
  }

  public getSessionKey() {
    const core = Math.random().toString(36).replace(".", "");

    const key =
      "session-" +
      currentUserId() +
      "-" +
      core +
      "-" +
      new Date().getTime().toString();

    console.log(key);

    return key;
  }

  public handleLessonClick = (
    lesson,
    isActive,
    completed,
    nextLesson,
    e = null
  ) => {
    //  if (!isActive) {
    //    this.setState({ openInactiveModal: true });
    //    return;
    //  }

    if (currentSubscriptionLevel() < 1 || isLessonsEnabled() === false) {
      if (currentTargetGroup() === "schools") {
        toast.warn("Lessons are not available for you!");
        return;
      } else {
        toast.warn("Your subscription does not support this feature. Upgrade!");
        this.toPurchaseSubscription();
      }
    } else {
      const sessionKey = this.getSessionKey();
      lesson.sessionKey = sessionKey;

      setCurrentLesson(lesson);

      console.log(lesson);

      this.props.history.push(
        `${currentBaseUrl()}lessonview/${lesson.LessonId}`
      );
    }
  };

  // public startCurrentLesson() {
  //   if (currentSubscriptionLevel() < 1 || isLessonsEnabled() === false) {
  //     if (currentTargetGroup() === "schools") {
  //       toast.warn("Lessons are not available for you!");
  //       return;
  //     } else {
  //       toast.warn("Your subscription does not support this feature. Upgrade!");
  //       this.toPurchaseSubscription();
  //     }
  //   } else {
  //     const currLesson = currentLesson();
  //     const currentLessonAlloc = this.state.lessonallocations[0];
  //     const key = "LessonId";
  //     const lessonTo =
  //       typeof currLesson[key] === "undefined"
  //         ? currentLessonAlloc
  //         : currLesson;
  //     this.props.history.push(`${currentBaseUrl()}lessonview/${lessonTo[key]}`);
  //     // this.setState({ navigate: true, destination: currentBaseUrl() + 'lessonview/' + lessonTo[key] });
  //     setCurrentLesson(lessonTo);
  //   }
  // }

  public handleCalendarClick = () => {
    if (currentSubscriptionLevel() < 1) {
      if (currentTargetGroup() === "schools") {
        toast.warn("Lessons are not available for you!");
        return;
      } else {
        toast.warn("Your subscription does not support this feature. Upgrade!");
        this.toPurchaseSubscription();
      }
    } else {
      setSelectedCalendarDay(this.state.date);
      this.props.history.push("/students/calendar");
      // this.setState({ toCalendar: true });
      // this.setState({ destination: "/students/calendar" });
    }
  };

  public handleBadgeClick(id) {
    // alert(`badge id ${id}`);
    this.setState({ clickedBadge: id, modalOpen: true });
  }

  public closeModal() {
    this.setState({ modalOpen: false });
  }

  public openAssessmentModal = () => {
    this.setState({ assessModalOpen: true });
  };
  public closeAssessmentModal = () => {
    this.setState({ assessModalOpen: false });
  };

  public toggleBehavModal() {
    const isOn = this.state.behaveModalOn;
    this.setState({ behaveModalOn: !isOn });
  }

  public startAssessment = () => {
    const { assessmentID, assessmentAvailable } = this.state;
    if (assessmentAvailable) {
      this.props.history.push(`${currentBaseUrl()}assessment/${assessmentID}`);
    } else {
      return;
    }
  };

  public onPostponeAssessment = () => {
    // reconsider possibly a useless function
    const { assessmentID, assessmentAvailable } = this.state;
    this.setState({ assessModalOpen: false });
  };

  public badgesModal() {
    if (this.state.clickedBadge) {
      return (
        <Modal
          visible={this.state.modalOpen}
          effect="fadeInDown"
          onClickAway={this.closeModal}
        >
          <div className="badges-modal-container">
            <p className="badge-id">
              Badge ID: <span>{this.state.clickedBadge}</span>
            </p>
            <p className="badge-descript">Some Info about this badge coming</p>
          </div>
        </Modal>
      );
    } else {
      return <Loader color="#ff0033;" />;
    }
  }
  public renderCourseVideoModal() {
    const { showCourseVideo, courseVideo } = this.state;

    if (courseVideo.length) {
      return (
        <Modal
          visible={showCourseVideo}
          effect="fadeInDown"
          // tslint:disable-next-line jsx-no-lambda
          onClickAway={() => {
            this.setState({ showCourseVideo: false });
          }}
        >
          <div className="badges-modal-container">
            <Vimeo video={courseVideo} width="450px" />
          </div>
        </Modal>
      );
    } else {
      return <Loader color="#ff0033;" />;
    }
  }

  public renderDownloadAssessmentModal() {
    const { assessments, openDownloadModal } = this.state;

    return (
      <Modal
        visible={openDownloadModal}
        effect="fadeInDown"
        // tslint:disable-next-line jsx-no-lambda
        onClickAway={() => this.setState({ openDownloadModal: false })}
      >
        <div className="badges-modal-container">
          <p className="exit-warning">Please pick an assessment to download</p>

          <select
            className="custom-select sf-select"
            onChange={this.downloadAssessmentReport}
            style={{ width: "380px" }}
          >
            <option value=""> -- Pick an assessment -- </option>
            {assessments.map((assessment: any) => (
              <option key={`download-${assessment.id}`} value={assessment.id}>
                {assessment.Title}
              </option>
            ))}
          </select>
        </div>
      </Modal>
    );
  }

  public renderAllBehaviours() {
    const { allBehaviours, allBehavsLoaded } = this.state;

    if (allBehavsLoaded) {
      const behaviourItems = Object.keys(allBehaviours);
      // console.log("BehaveInRender: " + behaviourItems.length)

      let assessment = "";
      let behaviours = new Array();

      if (behaviourItems.length) {
        assessment = allBehaviours.AssessmentName;
        behaviours = allBehaviours.behaviours;
      }

      const childrenNodes = new Array();
      behaviours.forEach((behaviour) => {
        childrenNodes.push({
          name: behaviour.Name,
          score: behaviour.Score,
          vidID: behaviour.Video !== null ? behaviour.Video.VideoData.id : "",
        });
      });

      const graphData = {
        name: assessment,
        children: childrenNodes,
      };

      return (
        <Modal
          visible={this.state.behaveModalOn}
          effect="fadeInDown"
          onClickAway={this.toggleBehavModal}
          width="900"
          height="600"
        >
          <div className="all-behaviours-container">
            <p>All your behaviours in your last assessment</p>
            <div className="behaviours-wrapper">
              {allBehaviours.behaviours.length > 0 ? (
                <BubbleChart
                  realData={graphData}
                  identity="name"
                  value="score"
                  isReady={true}
                  leavesOnly={true}
                  colorBy="name"
                />
              ) : (
                <p className="behaviours-title">
                  you haven't done any post lesson assessments
                </p>
              )}
            </div>
          </div>
        </Modal>
      );
      // }else {
      //   return <p>You haven't done any Post Lesson Assessments yet</p>
      // }
    } else {
      return <Loader color="#3ee9f700" />;
    }
  }

  public renderAssessmentInfoModal = () => {
    return (
      <Modal
        visible={this.state.assessModalOpen}
        effect="fadeInDown"
        height="200"
        width="400"
      >
        <div className="exit-modal-container">
          <p className="exit-warning">Please complete your next assessment</p>

          <div className="exit-warning-buttons">
            <button className="blue-button" onClick={this.startAssessment}>
              Take It Now
            </button>
            <button className="red-button" onClick={this.onPostponeAssessment}>
              Take It Later
            </button>
            {/* <button className="green-button" onClick={this.closeAssessmentModal}>I'll stay</button> */}
          </div>
        </div>
      </Modal>
    );
  };

  public renderNextCourseStartModal = () => {
    return (
      <Modal
        visible={this.state.nextCourseModalOpen}
        effect="fadeInDown"
        height="200"
        width="400"
      >
        <div className="exit-modal-container">
          <p className="exit-warning">
            You have completed all the lessons in your current course. Would you
            like to start this as the next course?
          </p>

          <div className="exit-warning-buttons">
            <button className="blue-button" onClick={this.startNextCourse}>
              Start Next Course
            </button>

            <button
              className="red-button"
              // tslint:disable-next-line jsx-no-lambda
              onClick={() => {
                this.setState({ nextCourseModalOpen: false });
              }}
            >
              Keep Looking
            </button>
            {/* <button className="green-button" onClick={this.closeAssessmentModal}>I'll stay</button> */}
          </div>
        </div>
      </Modal>
    );
  };

  public renderInactiveLessonModal = () => {
    console.log("renderInactiveLessonModal");
    console.log(this.state.nextlesson);

    if (this.state.nextlesson.id === 0 && this.state.openInactiveModal) {
      this.setState({ openInactiveModal: false, nextCourseModalOpen: true });

      return "";
    } else {
      return (
        <Modal
          visible={this.state.openInactiveModal}
          effect="fadeInDown"
          height="200"
          width="400"
          // tslint:disable-next-line jsx-no-lambda
          onClickAway={() => {
            this.setState({ openInactiveModal: false });
          }}
        >
          <div className="exit-modal-container">
            {}
            <p
              style={{
                fontFamily: "Roboto Condensed",
                textAlign: "center",
                color: "#fff",
                fontSize: "18px",
              }}
            >
              Loving the enthusiasm! <br /> Complete your existing pathways to
              unlock these. <br />
              <br />
              <span style={{ color: "var(--green)", fontWeight: "bold" }}>
                Onwards &amp; Upwards!
              </span>
            </p>
            <button
              // tslint:disable-next-line jsx-no-lambda
              onClick={() => {
                this.setState({ openInactiveModal: false });
              }}
              className="red-button"
            >
              Ok, Cool
            </button>
          </div>
        </Modal>
      );
    }
  };

  public renderLessonWarningModal = () => {
    const { lessonStartDetails, lessonStartWarningModal } = this.state;

    return (
      <Modal
        visible={lessonStartWarningModal}
        effect="fadeInDown"
        height="200"
        width="400"
        // tslint:disable-next-line jsx-no-lambda
        onClickAway={() => {
          this.setState({ lessonStartWarningModal: false });
        }}
      >
        <div className="exit-modal-container">
          <p
            style={{
              fontFamily: "Roboto Condensed",
              textAlign: "center",
              color: "#fff",
              fontSize: "18px",
            }}
          >
            Woah! You are moving fast, great stuff. We recommend one pathway
            every &nbsp;
            <span style={{ color: "var(--green)", fontWeight: "bold" }}>
              7-days.
            </span>
          </p>

          <div>
            <button
              // tslint:disable-next-line jsx-no-lambda
              onClick={() => {
                this.setState({ lessonStartWarningModal: false });
              }}
              className="green-button"
              style={{ padding: "0 2em" }}
            >
              Ok, got it.
            </button>

            <button
              // tslint:disable-next-line jsx-no-lambda
              onClick={this.handleLessonClick.bind(
                this,
                lessonStartDetails.lesson,
                lessonStartDetails.isActive,
                lessonStartDetails.completed,
                lessonStartDetails.nextLesson
              )}
              className="red-button"
              style={{ marginLeft: "1em" }}
            >
              No, I want to move fast.
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  public renderScoreSummaryTiles = () => {
    const { standardScores, scoresLoaded, mounted } = this.state;
    return scoresLoaded && mounted ? (
      <div className="result-card">
        <ScoreSummary scores={standardScores} />
      </div>
    ) : (
      <></>
    );
  };

  public render() {
    const { completedLessons, assessmentAvailable, mounted, topreassessment } =
      this.state;
    const nxtkey = "eta";
    const coursekey = "Title";
    if (this.state.tologin === true) {
      return <Redirect to="/login" />;
    }

    if (this.state.toProfile === true) {
      return <Redirect to={this.state.baseurl + "profile"} />;
    }

    if (this.state.toupgradedpreassessment === true) {
      return <Redirect to={this.state.baseurl + "proassessment/0"} />;
    }

    if (this.state.topreassessmentresult === true) {
      return (
        <Redirect to={this.state.baseurl + "preassessmentresult/students"} />
      );
    }

    if (this.state.navigate === true) {
      return <Redirect to={this.state.destination} />;
    }

    if (this.state.toCalendar === true) {
      return <Redirect to={this.state.destination} />;
    }
    return (
      <div style={{ height: "100vh", overflowY: "scroll" }}>
        <ToastContainer autoClose={8000} />
        <CustomNav
          {...this.props}
          logoutParent={this.onLogout}
          profileParent={this.onProfile}
        />
        {assessmentAvailable || !isSubscriptionOwner() ? (
          ""
        ) : (
          <Tour
            steps={tourSteps}
            isOpen={!this.state.guidesRead}
            onRequestClose={this.closeTour}
            onAfterOpen={this.disableBody}
            onBeforeClose={this.enableBody}
            accentColor="#ff0033"
          />
        )}

        {this.badgesModal()}
        {this.renderAllBehaviours()}
        {plLevel() < 1 ? this.renderAssessmentInfoModal() : ""}
        {this.renderInactiveLessonModal()}
        {this.renderLessonWarningModal()}
        {this.renderCourseVideoModal()}
        {this.renderNextCourseStartModal()}
        {/* {this.renderDownloadAssessmentModal()} */}
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <Row className="row-item align-items-center">
            <div className="student-homepage-container">
              <div className="top-after-bar">
                <h4 className="welcome-message" style={{ width: "auto" }}>
                  Hi <span>{userFirstName()}</span> , are you Ready <br /> to
                  smash it today
                </h4>

                <button className="start-now" onClick={this.toDataCenterTemp}>
                  REFLECT <br />
                  <span>ON YOUR PERFORMANCE HERE</span>
                </button>
              </div>

              {this.renderScoreSummaryTiles()}
              {/* {this.renderTopBottomBehaviours()} */}
              {/* <div
                className="result-card step-4"
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <p className="assessment-header">
                  Check out all your performance here
                </p>
                <button
                  className="green-button watch-video"
                  onClick={this.toDataCenterTemp}
                >
                  Learn more in the Data center
                </button>
              </div> */}

              {this.svgInfo()}

              {this.recommendedCourses()}

              <div
                style={{ marginBottom: "4em" }}
                className="home-summary-card step-5"
              >
                <p
                  className="results-title"
                  style={{ paddingTop: "2em", marginBottom: "0" }}
                >
                  {this.state.currentCourse[coursekey]}
                </p>

                {this.state.lessonsLoading ? (
                  ""
                ) : (
                  <Animated
                    animationIn="slideInUp"
                    animationOut="fadeOut"
                    isVisible={true}
                    animationInDuration={800}
                  >
                    <div className="home-summary-content">
                      <div className="lesson-plan">
                        <p
                          style={{ marginTop: "-16px" }}
                          className="results-title"
                        >
                          Your Lessons
                        </p>
                        <ScrollCard
                          children={this.state.lessonallocations.map(
                            (lesson, idx) => (
                              <LessonItem
                                key={`lessonallocation_${idx}_${lesson.LessonId}`}
                                isActive={this.state.activeCourses.includes(
                                  lesson.SearchFilterId
                                )}
                                lessontitle={
                                  typeof lesson.Name === "undefined"
                                    ? lesson.Title
                                    : lesson.Name
                                }
                                lessonindex={idx + 1}
                                completed={lesson.Completed}
                                icon={lesson.Thumbnail}
                                handleLessonClick={this.checkLessonStartValidity.bind(
                                  this,
                                  lesson,
                                  this.state.activeCourses.includes(
                                    lesson.SearchFilterId
                                  ),
                                  false,
                                  0
                                )}
                              />
                            )
                          )}
                          scrollable={true}
                          maxHeight={600}
                          scrollJumpSize={160}
                        />

                        <button
                          style={{ display: "none" }}
                          className="lesson-schedule green-button step-6"
                          onClick={this.handleCalendarClick}
                        >
                          Go to your lessons schedule
                        </button>
                      </div>
                    </div>
                  </Animated>
                )}
              </div>

              <div style={{ width: "100%", display: "none", marginTop: "5em" }}>
                <h4 className="results-title">MY ACHIEVEMENTS</h4>
                <BadgesDisplay
                  badges={this.state.badges}
                  idkey="id"
                  namekey="Name"
                  earnedkey="Earned"
                  isUserUpgraded={1}
                  onBadgeClick={this.handleBadgeClick}
                />
              </div>

              <Row
                style={{
                  width: "100%",
                  marginTop: "5em",
                  justifyContent: "flex-end",
                }}
                className="for-student-stories"
              >
                {/* <DownloadReport
                  onDownloadAssessmentReport={this.fetchStudentAssessments}
                /> */}
                {/* <Col
                  className="student-story-cont"
                  xs="12"
                  md="12"
                  lg="12"
                  xl="6"
                >
                  <StudentStory />
                </Col>
                <Col
                  // style={{ visibility: "hidden" }}
                  xs="12"
                  md="12"
                  lg="12"
                  xl="6"
                >
                  <Enquiry toHelpCenter={this.toHelpCenter} />
                </Col> */}
              </Row>
              {assessmentAvailable ? (
                <PendingAssessment goToAssessment={this.startAssessment} />
              ) : (
                ""
              )}
            </div>
          </Row>
        </CSSTransition>
        {mounted &&
        !assessmentAvailable &&
        false &&
        !topreassessment &&
        plLevel() < 1 ? (
          <div className="homepage-overlay">
            <div className="overlay-content">
              <i
                style={{ color: "#acff24", fontSize: "32px" }}
                className="fa fa-trophy"
              />
              <h2 className="overlay-content-heading">Great Job!</h2>
              <p className="overlay-content-body">
                Congratulations on completing your assessment. Your next
                assessment is due in 3-months. <br /> <br /> Now go have a great
                day and well done from Performance Learning for today.
              </p>
              <p className="user-interest">
                I am interested in getting more out of Performance Learning{" "}
                <br />
                <i
                  onClick={this.toggleUserInterest.bind(this, true)}
                  className="fa fa-thumbs-up"
                  style={{
                    color: `${this.state.userInterested ? "#acff24" : "#ccc"}`,
                  }}
                />
                &nbsp;&nbsp;
                <i
                  onClick={this.toggleUserInterest.bind(this, false)}
                  className="fa fa-thumbs-down"
                  style={{
                    color: `${
                      this.state.userInterested !== null &&
                      !this.state.userInterested
                        ? "#ff0033"
                        : "#ccc"
                    }`,
                  }}
                />
              </p>
              <button
                className="overlay-button green-button"
                onClick={this.onLogout}
              >
                Thank You
              </button>
            </div>
          </div>
        ) : (
          ""
        )}

        {mounted && !assessmentAvailable && topreassessment ? (
          <div className="homepage-overlay">
            <div className="overlay-content">
              <i className="fa fa-trophy" />
              <h2 className="overlay-content-heading">We are working on it</h2>
              <p className="overlay-content-body">
                We are currently generating your assessment, please log out and
                log back in a minute or two.
              </p>
              <button
                className="overlay-button green-button"
                onClick={this.onLogout}
              >
                Thank You
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default withServices(StudentHomePage);



// WEBPACK FOOTER //
// ./src/pages/Home/studentHomePage.Component.tsx